import script from "./SearchDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchDetails.vue?vue&type=script&lang=ts&setup=true"

import "./SearchDetails.vue?vue&type=style&index=0&id=71e80d9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e80d9e"]])

export default __exports__